import { arrayToMap } from "utils/custom.utils"

export const ORDER_STATUSES = [
  {
    name: "Not Placed",
    intent: "warning",
    id: "NPL",
  },
  {
    name: "Placed",
    intent: "warning",
    id: "PLC",
  },
  {
    name: "Confirmed",
    intent: null,
    id: "CNF",
  },
  {
    name: "In Process",
    intent: null,
    id: "IPR",
  },
  {
    name: "Ready For Despatch",
    intent: null,
    id: "RFD",
  },
  {
    name: "Ready for Schedule",
    intent: null,
    id: "RFS",
  },
  {
    name: "Despatched",
    intent: null,
    id: "DES",
  },
  {
    name: "Reject",
    intent: "danger",
    id: "CBV",
  },
  {
    name: "Cancelled By User",
    intent: "danger",
    id: "CBU",
  },
  {
    name: "Completed",
    intent: "success",
    id: "CMP",
  },
  {
    // name: "Partial Reject",  Change as Manoj -> Partial Completed
    name: "Partial Completed",
    intent: "danger",
    id: "PRJ",
  },
  {
    name: "Full Reject",
    intent: "danger",
    id: "FRJ",
  },
]
export const orderStatusMap = arrayToMap(ORDER_STATUSES)
export const EDIT_ORDER_STATUSES = [
  {
    name: "Placed",
    id: "PLC",
  },
  {
    name: "Confirmed",
    id: "CNF",
  },
  {
    name: "In Process",
    id: "IPR",
  },
  {
    name: "Ready For Despatch",
    id: "RFD",
  },
  {
    name: "Ready For Schedule",
    id: "RFS",
  },
  {
    name: "Reject",
    id: "CBV",
  },
]
export const ORDER_STATUS_FLOW = {
  NPL: ["PLC", "CBV", "CBU"],
  PLC: ["CNF", "CBU", "CBV"],
  CNF: ["CBU", "IPR", "CBV"],
  IPR: ["CNF", "RFS", "CBU", "CBV"],
  RFD: ["CBU", "DES", "SFD", "RFS"],
  RFS: ["CBU", "RFD", "SFD", "CBV"],
  CBV: ["CBV"],
}
